import { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const FORMATS = ['bold', 'italic', 'underline', 'list', 'bullet', 'link'];

export default function EditorRequisitos({ value, onChange, disabled = false, placeholder = 'Escribe aquí los requisitos del curso...' }) {
  // Handler propio del botón "link": si el usuario escribe una URL sin
  // protocolo (www.x.es), se inserta con https:// delante para que el enlace
  // sea absoluto (Quill, por defecto, lo trataría como ruta relativa).
  const modules = useMemo(() => ({
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
        ['clean'],
      ],
      handlers: {
        link: function (clicked) {
          if (clicked) {
            const range = this.quill.getSelection();
            if (!range || range.length === 0) return;
            const href = window.prompt('Introduce la URL:');
            if (!href) return;
            const normalizado = /^(https?:|mailto:|tel:)/i.test(href) ? href : `https://${href}`;
            this.quill.format('link', normalizado);
          } else {
            this.quill.format('link', false);
          }
        },
      },
    },
  }), []);

  return (
    <div className="space-y-2">
      <ReactQuill
        theme="snow"
        modules={modules}
        formats={FORMATS}
        value={value || ''}
        onChange={onChange}
        readOnly={disabled}
        placeholder={placeholder}
      />
      <p className="text-xs text-slate-400">
        Formatos disponibles: negrita, cursiva, subrayado, listas y enlaces.
      </p>
    </div>
  );
}
